import { Grid, Paper } from "@material-ui/core";
import React from "react";
import ContentCategory from "../../../components/CategoryManagement/ContentCategory";

export default function Category() {
    return (
        <Paper className="p-2 p-md-3 py-3 py-md-5">
            <Grid container spacing={0}>
                <Grid item xs={12} className="mb-3">
                    <h4>{" Skill Level Management "}</h4>
                </Grid>
                <Grid item xs={12}>
                    <ContentCategory />
                </Grid>
            </Grid>
        </Paper>
    );
}
